<template>
  <div class="cascadeItem">
    <div
      class="cascade-select"
      v-if="cascadeItem.children"
      @click="change(cascadeItem.username)"
    >
      <div :class="['label']">{{ cascadeItem.username }}</div>
      <i class="crm-Icon_right"></i>
    </div>
    <rich-checkbox-group
      v-else
      v-model="checkList"
      @input="checkboxChange(cascadeItem.username)"
    >
      <rich-checkbox
        class="checkbox-text"
        :option="cascadeItem.username"
      ></rich-checkbox>
    </rich-checkbox-group>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
const namespace = 'bizopp'
let checkboxList = []

export default {
  name: 'cascadeItem',
  data() {
    return {
      checkList: [],
      checkboxNum: 0
    }
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    cascadeItem: {
      type: Object,
      default: () => {}
    },
    cascadeIndex: {
      type: Number,
      default: 1
    },
    checkboxs: {
      type: Array,
      default: () => []
    },
    col: {
      type: Number,
      default: 3
    },
    paramKey: {}
  },
  watch: {
    options: {
      deep: true,
      immediate: true,
      handler(nVal) {
        this.checkList = checkboxList
      }
    },
    checkboxs: {
      handler(nVal) {
        if (nVal.length === 0) {
          this.checkList = []
          checkboxList = []
        }
      }
    }
  },
  computed: {
    ...mapState(namespace, {
      breadCrumbList: (state) => state.breadCrumbList
    })
  },
  methods: {
    ...mapMutations(namespace, [
      'updateSalesNameNum', // 更新销售姓名数量
      'updateBreadCrumbList' // 更新面包屑层级
    ]),
    change(name) {
      this.updateBreadCrumbList(name)
      this.$emit('showTreeList')
    },
    checkboxChange(value) {
      if (checkboxList.indexOf(value) === -1) {
        checkboxList.push(value)
        if (this.breadCrumbList.length) {
          this.setSaleName(this.options, value, true)
        } else {
          this.options[this.cascadeIndex].checkbox = true
        }
        this.$emit('checkboxNums', checkboxList)
      } else {
        checkboxList.splice(checkboxList.indexOf(value), 1)
        if (this.breadCrumbList.length) {
          this.setSaleName(this.options, value, false)
        } else {
          this.options[this.cascadeIndex].checkbox = false
        }
        this.$emit('checkboxNums', checkboxList)
      }
      // this.updateSalesNameData(this.options) // 后续做选中状态
      this.updateSalesNameNum(checkboxList.length)
    },
    // 改变选中状态
    setSaleName(data, value, blean) {
      data.forEach((item) => {
        if (item.username === value) {
          item.checkbox = blean
        } else if (item.children) {
          this.setSaleName(item.children, value, blean)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.cascade-select {
  position: relative;
  height: 112px;
  display: flex;
  align-items: center;
  color: #595c66;
  box-shadow: 0 1px 0 0 #e9eaee;
  box-sizing: border-box;
  margin-bottom: 1px;

  .label {
    flex: 1;
    font-family: DiDiSans-Pro-Regular;
    font-size: 36px;
    color: #282b33;
    line-height: 44px;
    font-weight: normal;
  }

  .select-status {
    color: #fc7633;
  }

  i {
    font-size: 20px;
    font-weight: 700;
  }
}
.rich-checkbox {
  height: 112px;
  padding: 0;
  ::v-deep .rich-checkbox-pos {
    margin-right: 12px;
  }
  .checkbox-text {
    height: 112px;
    font-family: DiDiSans-Pro-Regular;
    font-size: 36px;
    color: #282b33;
    font-weight: normal;
  }
}
</style>
